import { render, staticRenderFns } from "./datos-ayudante.vue?vue&type=template&id=21dd1a8a&scoped=true&"
import script from "./datos-ayudante.component.ts?vue&type=script&lang=ts&"
export * from "./datos-ayudante.component.ts?vue&type=script&lang=ts&"
import style0 from "./datos-ayudante.vue?vue&type=style&index=0&id=21dd1a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dd1a8a",
  null
  
)

export default component.exports